var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_18915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2.00033H9.33333C9.7 2.00033 10 1.70033 10 1.33366C10 0.966992 9.7 0.666992 9.33333 0.666992H6.66667C6.3 0.666992 6 0.966992 6 1.33366C6 1.70033 6.3 2.00033 6.66667 2.00033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6867 4.92699L13.1867 4.42699C13.4401 4.17366 13.4467 3.75366 13.1867 3.49366L13.1801 3.48699C12.9201 3.22699 12.5067 3.23366 12.2467 3.48699L11.7467 3.98699C10.7134 3.16033 9.4134 2.66699 8.00007 2.66699C4.80007 2.66699 2.08007 5.30699 2.00007 8.50699C1.9134 11.8937 4.62673 14.667 8.00007 14.667C11.3201 14.667 14.0001 11.9803 14.0001 8.66699C14.0001 7.25366 13.5067 5.95366 12.6867 4.92699ZM8.66673 8.66699C8.66673 9.03366 8.36673 9.33366 8.00007 9.33366C7.6334 9.33366 7.3334 9.03366 7.3334 8.66699V6.00033C7.3334 5.63366 7.6334 5.33366 8.00007 5.33366C8.36673 5.33366 8.66673 5.63366 8.66673 6.00033V8.66699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_18915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3cb13341612e2eec04666fde828b1474.svg";
export { ForwardRef as ReactComponent };